import { useState } from "react";
import { Offcanvas, Button } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { AddActorJobDetails } from "../../../../../redux/action/client/JobForm";
import ErrorMessage from "../../../../common/ErrorMessage";
import Loader from "../../../../common/Loader";

function AddActorForm({ match, type, message, setReloadElements }) {
  const { jobId } = match.params;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setError("");
  };
  const handleShow = () => setShow(true);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    const dataValue = { job: Number(jobId), type: type };
    const finalResult = Object.assign(data, dataValue);
    dispatch(
      AddActorJobDetails(
        finalResult,
        setLoading,
        setError,
        handleClose,
        setReloadElements
      )
    );
    reset();
  };

  return (
    <>
      <div className="my-sm-0 my-2 me-sm-2">
        <Button
          onClick={handleShow}
          className="atech-primary-button  primary-button-padding mr-10 w-100"
        >
          {message}
        </Button>

        <Offcanvas
          className="Sidebar-width h-100vh "
          show={show}
          onHide={handleClose}
          placement="end"
        >
          <Offcanvas.Body className="d-flex justify-content-center  py-lg-2">
            <div className="container">
              <Offcanvas.Header
                className="p-0 py-3 d-flex justify-content-end"
                closeButton
              ></Offcanvas.Header>
              <h1 className="dash_head pb-lg-4 pb-3 ">{message}</h1>
              <form onSubmit={handleSubmit(onSubmit)}>
                {error !== "" ? <ErrorMessage message={error} /> : ""}
                <div className="row ">
                  <div className="col-lg-4 col-sm-6  ">
                    <div className="my-2">
                      <input
                        {...register("age", { required: true })}
                        type="number"
                        min="1"
                        className="form-control py-3 atech-input inputs_font_size"
                        placeholder="Age"
                      />
                      {errors.age?.type === "required" && (
                        <p className="common-text xxs-font text-red">
                          Age is required
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6  ">
                    <div className="my-2">
                      <input
                        {...register("heights", { required: true })}
                        type="number"
                        min="1"
                        className="form-control py-3 atech-input inputs_font_size"
                        placeholder="Height (cm)"
                      />
                      {errors.heights?.type === "required" && (
                        <p className="common-text xxs-font text-red">
                          Heights is required
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4 col-12 ">
                    <div className="my-2">
                      <input
                        {...register("eye_color", { required: true })}
                        type="text"
                        className="form-control py-3 atech-input inputs_font_size"
                        placeholder="Eye Color "
                      />
                      {errors.eye_color?.type === "required" && (
                        <p className="common-text xxs-font text-red">
                          Eye Color is required
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row ">
                  <div className="col-lg-4 col-sm-6 ">
                    <div className="my-2">
                      <input
                        {...register("ethnicity", { required: true })}
                        type="text"
                        className="form-control py-3 atech-input inputs_font_size"
                        placeholder="Ethnicity"
                      />
                      {errors.ethnicity?.type === "required" && (
                        <p className="common-text xxs-font text-red">
                          Ethnicity is required
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6 ">
                    <div className="my-2">
                      <input
                        {...register("hair_color", { required: true })}
                        type="text"
                        className="form-control py-3 atech-input inputs_font_size"
                        placeholder="Hair"
                      />
                      {errors.hair_color?.type === "required" && (
                        <p className="common-text xxs-font text-red">
                          Hair is required
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4 col-12">
                    <div className=" select-field my-2">
                      <select
                        className="form-select py-3 cursor-pointer inputs_font_size"
                        {...register("gender", { required: true })}
                      >
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="others">others</option>
                      </select>
                      {errors.gender?.type === "required" && (
                        <p className="common-text xxs-font text-red">
                          Gender is required
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row ">
                  <div className="col-12">
                    <div className="my-2">
                      <input
                        type="text"
                        {...register("clothings", { required: true })}
                        className="form-control py-3 atech-input inputs_font_size"
                        placeholder="Clothing/Makeup"
                      />
                      {errors.clothings?.type === "required" && (
                        <p className="common-text xxs-font text-red">
                          Clothings/Makeup is required
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row ">
                  <div className="col-12">
                    <div className="my-2">
                      <input
                        {...register("body_type", { required: true })}
                        type="text"
                        className="form-control py-3 atech-input inputs_font_size"
                        placeholder="Body type e.g. athletic"
                      />
                      {errors.body_type?.type === "required" && (
                        <p className="common-text xxs-font text-red">
                          Clothings/Makeup is required
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="my-2">
                  <Form.Group
                    className=" textarea-focus"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Control
                      {...register("other_details", { required: true })}
                      placeholder="Other details e.g. character name"
                      as="textarea"
                      rows={5}
                      className="inputs_font_size"
                    />
                    {errors.other_details?.type === "required" && (
                      <p className="common-text xxs-font text-red">
                        Other details is required
                      </p>
                    )}
                  </Form.Group>
                </div>
                <div className="my-2">
                  <Form.Group
                    className=" textarea-focus"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Control
                      {...register("actions", { required: true })}
                      placeholder="Actions : What would you like the actor to do?"
                      as="textarea"
                      rows={5}
                      className="inputs_font_size"
                    />
                    {errors.actions?.type === "required" && (
                      <p className="common-text xxs-font text-red">
                        Actions is required
                      </p>
                    )}
                  </Form.Group>
                </div>
                <div className="my-2">
                  <Form.Group
                    className=" textarea-focus"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Control
                      {...register("dialogs", { required: true })}
                      placeholder="Dialogue: What would you like the actor to say?"
                      as="textarea"
                      rows={5}
                      className="inputs_font_size"
                    />
                    {errors.dialogs?.type === "required" && (
                      <p className="common-text xxs-font text-red">
                        Dialogs is required
                      </p>
                    )}
                  </Form.Group>
                </div>
                <div className="d-flex flex-sm-row  flex-column mt-3">
                  <button
                    className={`${
                      loading ? "cursor-not-allowed" : ""
                    } px-4 atech-primary-button  py-sm-2 py-2 ms-sm-2  my-2`}
                    disabled={loading}
                  >
                    {loading ? <Loader /> : "Save"}
                  </button>
                  <button
                    className="px-4  py-sm-2 py-2 ms-sm-2  my-2  atech-fade-button"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
}

export default withRouter(AddActorForm);
